export default __webpack_public_path__ + "static/media/south32.06c0bc9b.svg";